export default __webpack_public_path__ + "static/media/Tierno.3a29f61c.jpg";